import React, { useState } from "react";
import { useLocalizedStrings } from "../Localization";  // Localization'dan hook'u import ediyoruz

const About = () => {
  const strings = useLocalizedStrings(); // Dil dosyasından çevirileri alıyoruz

  // Lokalize sekme başlıkları
  const tabTitles = {
    personalInfo: strings.personalInfoTitle,
    experience: strings.experienceTitle,
    education: strings.educationTitle,
    hobbies: strings.hobbiesTitle
  };

  // İçerik bölümleri
  const sections = {
    personalInfo: strings.personalInfo,
    experience: strings.experience,
    education: strings.education,
    hobbies: strings.hobbies
  };

  const [activeSection, setActiveSection] = useState("personalInfo");

  return (
    <div className="flex flex-col md:flex-row items-center py-20 justify-center min-h-[400px]">
      <div className="relative flex flex-col md:flex-row w-[90%] md:w-[80%] border-4 border-black bg-white shadow-xl rounded-xl">
        <div 
          id="about" 
          className="absolute -top-14 left-5 bg-black text-white px-4 py-2 text-4xl rounded-t-lg"
          style={{ fontFamily: 'Bokor' }}
        >
          {strings.aboutMe} {/* Dil dosyasından "About Me" başlığı */}
        </div>
        
        {/* Sol Sekmeler */}
        <div className="md:w-1/4 bg-[#FFDCCC] text-black rounded-xl font-semibold md:p-4 p-2 flex flex-row cols-2 m-auto md:ml-0 md:flex-col md:space-y-4 overflow-auto">
          {Object.keys(tabTitles).map((key) => (
            <button
              key={key}
              onClick={() => setActiveSection(key)}
              className={`md:p-2 p-1 md:text-left text-center md:text-lg text-sm rounded-lg transition-all duration-300 border-2 border-transparent ${
                activeSection === key
                  ? "bg-white text-black shadow-xl"
                  : "hover:bg-[#B7B1F2] hover:text-black hover:border-black"
              }`}
            >
              {tabTitles[key]} {/* Sekme isimleri artık dil dosyasından gelecek */}
            </button>
          ))}
        </div>

        {/* Sağ İçerik Kartı */}
        <div className="md:w-5/6 p-6 flex items-center justify-center text-lg font-semibold text-gray-700">
          <div dangerouslySetInnerHTML={{ __html: sections[activeSection] }} />
        </div>
      </div>
    </div>
  );
};

export default About;
